type IconProps = {
  style?: React.CSSProperties;
};

export const FileCopyIcon = ({ style = {} }: IconProps) => {
  return (
    <img
      src="/assets/icons/file-copy-2-line.svg"
      alt="create"
      style={{ height: '2.4rem', ...style }}
    />
  );
};
